var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCloseIconActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 320,
    height: 321,
    viewBox: "0 0 320 321",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M310.6 266.4C323.1 278.9 323.1 299.15 310.6 311.65C304.4 317.9 296.2 321 288 321C279.8 321 271.62 317.875 265.38 311.625L160 206.3L54.63 311.6C48.38 317.9 40.19 321 32 321C23.81 321 15.63 317.9 9.375 311.6C-3.125 299.1 -3.125 278.85 9.375 266.35L114.775 160.95L9.375 55.5996C-3.125 43.0996 -3.125 22.8496 9.375 10.3496C21.875 -2.15039 42.125 -2.15039 54.625 10.3496L160 115.8L265.4 10.3996C277.9 -2.10039 298.15 -2.10039 310.65 10.3996C323.15 22.8996 323.15 43.1496 310.65 55.6496L205.25 161.05L310.6 266.4Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseIconActive);
export default __webpack_public_path__ + "static/media/close-icon-active.46d96b6a8041071c8ebfb1f89fdbeac7.svg";
export { ForwardRef as ReactComponent };